<template>
  <div class="landing-layout">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { core } from '@/config/pluginInit'

export default {
  name: 'LandingLayout',
  computed: {
    ...mapGetters({
      darkMode: 'settings/darkModeState'
    })
  },
  mounted () {
    try {
      core.index()
      core.mainIndex()
    } catch (error) {
      console.error('Landing layout init failed:', error)
    }

    this.modeChange({ rtl: false, dark: false })
  },
  destroyed () {
    document.body.classList = ''
  },
  methods: {
    ...mapActions({
      modeChange: 'settings/layoutModeAction'
    })
  }
}
</script>

<style scoped>
.landing-layout {
  min-height: 100vh;
  background-color: #f8faf8;
}
</style>
